import React from 'react'
import TopSec from '../../Component/Home/TopSec'
import Embrace from '../../Component/Home/Embrace'
import Sustain from '../../Component/Home/Sustain'
import Why from '../../Component/Home/Why'
import Word from '../../Component/Home/Word'
import Faq from '../../Component/Home/Faq'
import Compliance from '../../Component/Home/Compliance'
import Circle from '../../Component/Home/Circle'
import Seo from '../../Component/Seo'

function Home() {
  return (
    <div className='  '>
      <Seo
        title='Halal Savings, Investment and Asset Financing | Halal Wealth'
        description='Halal Wealth helps you save, invest, and finance assets without riba. Build ethical wealth with Shariah-compliant tools designed for Muslims.'
        pathname='/'
      />
      <TopSec />
      <section id="how-it-works">
        <Embrace />
      </section>
      <Sustain />
      {/* <Circle /> */}
      <Why />
      {/* <Compliance /> */}
      {/* <Word /> */}
      <Faq />
      
    </div>
  )
}

export default Home
